import api from '../axiosConfig';

export interface SearchConsoleSettings {
  id: number;
  product_id: number;
  site_url: string;
  is_connected: boolean;
  last_sync_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface SearchConsoleSettingInput {
  site_url: string;
  service_account_credentials?: string;
}

export interface SearchConsoleData {
  rows: Array<{
    keys: string[];
    clicks: number;
    impressions: number;
    ctr: number;
    position: number;
  }>;
}

export interface SearchConsoleSites {
  sites: Array<{
    siteUrl: string;
    permissionLevel: string;
  }>;
}

export const searchConsoleService = {
  /**
   * Get Search Console settings for a product
   */
  async getSettings(productId: number): Promise<SearchConsoleSettings> {
    const response = await api.get(`/api/products/${productId}/search-console/status`);
    return response.data;
  },

  /**
   * Save or update Search Console settings
   */
  async saveSettings(productId: number, data: SearchConsoleSettingInput): Promise<SearchConsoleSettings> {
    const response = await api.post(`/api/products/${productId}/search-console/connect`, data);
    return response.data;
  },

  /**
   * Disconnect Search Console
   */
  async disconnect(productId: number): Promise<void> {
    await api.delete(`/api/products/${productId}/search-console/disconnect`);
  },

  /**
   * Fetch Search Console data
   */
  async fetchData(
    productId: number,
    params: {
      start_date: string;
      end_date: string;
      dimensions?: string[];
      row_limit?: number;
    }
  ): Promise<SearchConsoleData> {
    const response = await api.post(`/api/products/${productId}/search-console/data`, params);
    return response.data.data;
  },

  /**
   * Get registered sites
   */
  async fetchSites(productId: number): Promise<SearchConsoleSites> {
    const response = await api.get(`/api/products/${productId}/search-console/sites`);
    return response.data.data;
  },
};
